const notImplemented = "Not implemented";

export const orderToasts = Object.freeze({
  created: (odNumber: string) => `Quote ${odNumber} created. Its identifier stays the same when it becomes an order.`,

  amending: (odNumber: string) =>
    `Amending the existing quote ${odNumber} — only one active quote is allowed per subscription.`,

  saved: "Changes saved.",

  accessRevoked: "Access revoked.",

  published: (endCustomerLegalName?: string) =>
    endCustomerLegalName
      ? `Quote published. ${endCustomerLegalName}’s subscription owners can now see it in the customer portal.`
      : "Quote published.",

  reopened: "Order reopened. It’s back in New status and can be edited again.",

  archived: "Order archived. It’s put away for good, and its status is unchanged.",

  accepted: "Order accepted. It’s now an immutable commercial record — invoicing takes over from here.",

  fulfilmentApproved: notImplemented,

  manualGateReapplied: notImplemented,

  internalConfirmationRecorded: notImplemented,

  billingRetryQueued: notImplemented,

  rateCardChanged: (rateCardCode: string) => `Quote repriced. It now uses rate card ${rateCardCode}.`,
});
